import { PublishResult, ApiPublishResult } from "./types";

export const parseAPIPublishResult = (apiPublishResult: ApiPublishResult): PublishResult => {
    return {
        type: apiPublishResult.type,
        message: apiPublishResult.message
    }
}
